import { AddToCartRequest, UpdateCartItemRequest } from '../types/cart';
import { BaseApiService } from './baseApiService';

/**
 * Service for shopping cart operations
 */
class CartService extends BaseApiService {
  async createCart() {
    await this.ensureInitialized();
    const response = await this.api.post('/cart/create');
    return response.data.cart;
  }

  async getCart(cartId: string) {
    await this.ensureInitialized();
    const response = await this.api.get(`/cart/${cartId}`);
    return response.data.cart;
  }

  async addToCart(cartId: string, request: AddToCartRequest) {
    await this.ensureInitialized();
    const response = await this.api.post(`/cart/${cartId}/items`, request);
    return response.data.cart;
  }

  async updateCartItem(cartId: string, request: UpdateCartItemRequest) {
    await this.ensureInitialized();
    const response = await this.api.put(`/cart/${cartId}/items`, request);
    return response.data.cart;
  }

  async removeFromCart(cartId: string, productId: string) {
    await this.ensureInitialized();
    await this.api.delete(`/cart/${cartId}/items`, {
      data: { ProductId: productId },
    });
  }

  async clearCart(cartId: string) {
    await this.ensureInitialized();
    await this.api.delete(`/cart/${cartId}`);
  }
}

export const cartService = new CartService();
export default cartService;
